// Regional number / date / time presentation — mirrors the Outlook app's lib/locale so the
// phone formats money/dates/times the SAME way the user chose in the pane (EU default or US).
// Cached in localStorage (synced from the account on each session probe; see app.ts).
const KEY = "rplay-locale";

export type Region = "eu" | "us";

/** Active BCP-47 locale (call-time). Default = EU. */
export function getLocale(): string {
  try { const v = localStorage.getItem(KEY); if (v && v.trim()) return v; } catch { /* blocked */ }
  return "nl-BE";
}
export function setRegion(r: Region): void {
  try { localStorage.setItem(KEY, r === "us" ? "en-US" : "nl-BE"); } catch { /* no-op */ }
}

/** Currency amount in the active locale ("10.000,50 €" / "$10,000.50"). */
export function fmtMoney(n?: number | null, currency = "EUR"): string {
  if (n == null || !Number.isFinite(n)) return "";
  try { return new Intl.NumberFormat(getLocale(), { style: "currency", currency: currency || "EUR" }).format(n); }
  catch { return `${currency || "EUR"} ${n.toFixed(2)}`; }
}

/** Numeric date in the active locale (EU "17/06/2026" · US "06/17/2026"). */
export function fmtDate(d?: string | null): string {
  if (!d) return "";
  const s = String(d).slice(0, 10);
  const dt = new Date(`${s}T00:00:00`);
  if (isNaN(dt.getTime())) return s;
  try { return dt.toLocaleDateString(getLocale(), { day: "2-digit", month: "2-digit", year: "numeric" }); }
  catch { return s; }
}

/** Time-of-day in the active locale (EU "15:00" · US "3:00 PM"). Accepts "HH:MM" or ISO. */
export function fmtTime(t?: string | null): string {
  if (!t) return "";
  const s = String(t).trim();
  let dt: Date;
  if (/^\d{1,2}:\d{2}/.test(s)) { const [h, m] = s.split(":"); dt = new Date(2000, 0, 1, Number(h), Number(m)); }
  else { dt = new Date(s); }
  if (isNaN(dt.getTime())) return s;
  try { return dt.toLocaleTimeString(getLocale(), { hour: "numeric", minute: "2-digit" }); }
  catch { return s; }
}
